/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'embedded-confluence-common.src.content.empty-state-description': '我们已四处寻找，但它并不存在。它可能已被删除。除非您的 URL 包含错别字 😉',
  'embedded-confluence-common.src.content.empty-state-header': '未找到您要查找的页面',
  'embedded.confluence.already-logged-in-paragraph': '已登录？请尝试刷新。',
  'embedded.confluence.footer.hover.text': '在 Confluence 中查看',
  'embedded.confluence.footer.prefix': '技术支持：',
  'embedded.confluence.generic-error-page.login-to-confluence-button': '登录到 Confluence',
  'embedded.confluence.login-page.login-button': '登录 Confluence',
  'embedded.confluence.login-page.login-button.aria-label': '登录按钮',
  'embedded.confluence.login-page.login-text': '您需要登录才能查看此页面',
  'embedded.confluence.login-page.refresh-page-banner': '登录后，此页面应会自动刷新。如果未刷新，您可以点击此处进行刷新',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': '刷新页面',
  'embedded.confluence.need-to-log-in-paragraph': '您需要登录才能查看此页面',
  'embedded.confluence.still-having-trouble-paragraph': '仍有问题？请确保已启用第三方 Cookie，或{link}',
  'embedded.confluence.troubleshooting-link-text': '参阅此故障排除指南。',
  'embedded.confluence.troubleshooting-link.aria-label': '故障排除指南链接'
};